// extracted by mini-css-extract-plugin
export default {"root":"MainVideo_root__XmeD5","layout-container":"MainVideo_layout-container__NOFMM","container":"MainVideo_container__U77Gb"};
    if(module.hot) {
      // 1763446807850
      var cssReload = require("/usr/src/app/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  